import { createTheme } from '@mantine/core';

export const theme = createTheme({
  primaryColor: 'coral',
  colors: { coral: ['#fff0f1', '#ffdee1', '#ffbdc3', '#ff969f', '#f77984', '#ec6b73', '#dc525f', '#bd3f4c', '#a83744', '#942d3b'] },
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  headings: { fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', fontWeight: '700' },
  defaultRadius: 'md',
  components: { Button: { defaultProps: { fw: 600 } }, Paper: { defaultProps: { radius: 'lg' } } },
});
